import { CheckCircleOutlined } from "@ant-design/icons";
import classes from "./ReferralIndicator.module.css";
import { IReferralIndicatorProps } from "../../../../interfaces/Ui/AdminAgentInfo/IReferralIndicatorProps";

export const ReferralIndicator = ({
  icon = <CheckCircleOutlined color="primary" />,
  children = (
    <div className={classes.text}>
      Пользователь зарегистрирован по реферальной ссылке
    </div>
  ),
  className = "",
  ...restProps
}: IReferralIndicatorProps) => {
  const concatClassName = `${className} ${classes.referral}`;
  return (
    <div {...restProps} className={concatClassName}>
      {icon} {children}
    </div>
  );
};
